import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function Spinner({ size = 40, className = "" }) {
  return (
    <div
      className={`rounded-full border-4 border-[#F6DED5] border-t-[#E86A45] animate-spin ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function FullPageSpinner() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Spinner />
    </div>
  );
}

export function PageHeader({ title, subtitle, right, backTo }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-start gap-3 mb-6">
      {backTo !== undefined && (
        <button
          data-testid="page-back-btn"
          onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
          className="mt-1 h-9 w-9 shrink-0 rounded-full bg-[#F2EFE9] hover:bg-[#E8E3DA] flex items-center justify-center transition-colors"
          aria-label="Back"
        >
          <ChevronLeft size={20} color="#2D2B2A" />
        </button>
      )}
      <div className="flex-1 min-w-0">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#2D2B2A] tracking-tight">
          {title}
        </h1>
        {subtitle && <p className="text-[#4A4746] mt-1 text-sm sm:text-base">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      {Icon && (
        <div className="h-16 w-16 rounded-3xl bg-[#F6DED5] flex items-center justify-center mb-4">
          <Icon size={30} color="#E86A45" />
        </div>
      )}
      <h3 className="font-display text-xl font-extrabold text-[#2D2B2A]">{title}</h3>
      {body && <p className="text-[#4A4746] mt-1.5 max-w-sm">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function PrimaryButton({ children, className = "", loading, ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#E86A45] text-white font-extrabold px-6 py-3 shadow-sm hover:bg-[#d65f3c] active:scale-[0.98] transition-all disabled:opacity-60 disabled:pointer-events-none ${className}`}
    >
      {loading ? <Spinner size={20} className="!border-white/40 !border-t-white" /> : children}
    </button>
  );
}
